import React, { useContext, useState } from 'react';
import { CustomerContext } from '../CustomerContext';
import { Memo, useMemoService } from '../../../sdk/MemoServiceClient';
import { useAsyncEffect } from '../../../hooks/UseAsyncEffect';
import { AddEditMemo } from './AddEditMemo';
import { toFormattedDate } from '../../../utilities/FormatHelpers';
import { Error } from '@app/shared';
import { useGlobalContext } from '../../../GlobalContextProvider';

export function CustomerMemos() {
  const { customerId } = useContext(CustomerContext);
  const { tenantId } = useGlobalContext();
  const memoService = useMemoService(tenantId);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [memos, setMemos] = useState<Memo[]>([]);
  const [memoAdded, setMemoAdded] = useState<number>(1);

  useAsyncEffect(async () => {
    try {
      setIsLoading(true);
      const memoResponse = await memoService.getCustomerMemos(customerId);
      setIsLoading(false);
      if (memoResponse){
        setMemos(memoResponse?.memos);
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
    }
  }, [customerId, memoAdded]);

  function onMemoAdded() {
    setMemoAdded((memoAdded) => memoAdded + 1);
  }

  return (
    <>
      <h2>Memos</h2>
      <Error error={error} />
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && memos && (
        <table className="ui compact table">
          <thead>
            <tr>
              <th>Note</th>
              <th>Created</th>
              <th>Created By</th>
            </tr>
          </thead>
          <tbody>
            {memos.map((memo) => (
              <tr key={memo.memoId}>
                <td>{memo.note}</td>
                <td>{toFormattedDate(memo.createdDate)}</td>
                <td>{memo.createdBy}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <AddEditMemo customerId={customerId} onMemoAdded={onMemoAdded} />
    </>
  );
}
